import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from './components/context/AuthContext'

function PrivateRoute({ children }) {
    const { userIsAuthenticated } = useAuth()
    return userIsAuthenticated() ? children : <Navigate to="/signin" />
}

export default PrivateRoute